import { render, staticRenderFns } from "./FmRate.vue?vue&type=template&id=4d0d4ba2&"
import script from "./FmRate.vue?vue&type=script&lang=js&"
export * from "./FmRate.vue?vue&type=script&lang=js&"
import style0 from "./FmRate.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports